import { getYear, format, parseISO } from 'date-fns';
import ListFilter from 'Shared/components/list-filter';


export const ALL = 'ALL';
export const SOLD = 'SOLD';
export const MONITORED = 'MONITORED';

const invoiceStateFilter = (invoice, { invoiceState }) => {
  switch (invoiceState) {
    case SOLD:
      return invoice.serviceId !== 2;
    case MONITORED:
      return invoice.serviceId === 2;
    case ALL:
    default:
      return true;
  }
};

const settledFilter = (invoice, { showDeducted }) => {
  if (showDeducted === false) {
    return invoice.isSettled === false
  }
  return true
}

const yearFilter = (invoice, { year }) => getYear(parseISO(invoice.ledgerDate)) === year;

const monthFilter = (invoice, { month }) => format(parseISO(invoice.ledgerDate), 'MMMM') === month;

const HistoricalLedgerFilter = (props) => (
  <ListFilter
    {...props}
    filterActions={[
      invoiceStateFilter,
      yearFilter,
      monthFilter,
      settledFilter,
    ]}
  />
);

export default HistoricalLedgerFilter;
